import { Suspense, lazy } from "react";
import HomeHero from "@/components/home/HomeHero";

// Lazy load below-the-fold components for code splitting
const About = lazy(() => import("@/components/home/About"));
const Courses = lazy(() => import("@/components/courses/Courses"));
const Community = lazy(() => import("@/components/community/Community"));
const CallToAction = lazy(() => import("@/components/home/CallToAction"));

// Loading fallback component
const SectionLoader = () => (
  <div className="w-full h-64 flex items-center justify-center">
    <div className="animate-pulse text-white/40">Loading...</div>
  </div>
);

const Index = () => {
  return (
    <main className="relative">
      {/* HomeHero - Loaded eagerly (above the fold) */}
      <HomeHero />
      
      {/* Below-the-fold sections - Lazy loaded with Suspense boundaries */}
      <Suspense fallback={<SectionLoader />}>
        <About />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <Courses />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <Community />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <CallToAction />
      </Suspense>
    </main>
  );
};

export default Index;
